const isRecord = value =>
  Boolean(value) && typeof value === 'object' && !Array.isArray(value);

export const readAgentLifecycle = management =>
  isRecord(management?.lifecycle) ? management.lifecycle : {};

export const readAgentLifecycleStatus = (management, fallbackMode) =>
  String(
    readAgentLifecycle(management).status ||
      management?.lifecycle_status ||
      fallbackMode ||
      'draft'
  ).toLowerCase();

export const presentAgentLifecycle = (status, t) => {
  const presentations = {
    active: [t('CAPTAIN_EXPERIENCE.WORKSPACE.LIFECYCLE_ACTIVE'), 'teal'],
    live: [t('CAPTAIN_EXPERIENCE.WORKSPACE.LIFECYCLE_ACTIVE'), 'teal'],
    silent: [t('CAPTAIN_EXPERIENCE.WORKSPACE.LIFECYCLE_SILENT'), 'blue'],
    paused: [t('CAPTAIN_EXPERIENCE.WORKSPACE.LIFECYCLE_PAUSED'), 'amber'],
    archived: [t('CAPTAIN_EXPERIENCE.WORKSPACE.LIFECYCLE_ARCHIVED'), 'slate'],
    draft: [t('CAPTAIN_EXPERIENCE.WORKSPACE.LIFECYCLE_DRAFT'), 'slate'],
  };
  const [label, tone] = presentations[status] || presentations.draft;
  return { label, tone };
};

export const readAgentHealthStatus = (
  management,
  { failedRunsCount = 0, hasCurrentTestRun = false } = {}
) => {
  const health = isRecord(management?.health) ? management.health : {};
  const runtime = isRecord(management?.runtime) ? management.runtime : {};
  const managedStatus =
    health.status || runtime.health_status || management?.health_status;
  if (managedStatus) return String(managedStatus).toLowerCase();
  if (failedRunsCount > 0) return 'needs_attention';
  return hasCurrentTestRun ? 'healthy' : 'not_tested';
};

export const presentAgentHealth = (status, t) => {
  const presentations = {
    healthy: [t('CAPTAIN_EXPERIENCE.WORKSPACE.HEALTH_HEALTHY'), 'teal'],
    ready: [t('CAPTAIN_EXPERIENCE.WORKSPACE.HEALTH_HEALTHY'), 'teal'],
    degraded: [t('CAPTAIN_EXPERIENCE.WORKSPACE.HEALTH_DEGRADED'), 'amber'],
    needs_attention: [
      t('CAPTAIN_EXPERIENCE.WORKSPACE.HEALTH_NEEDS_ATTENTION'),
      'ruby',
    ],
    unhealthy: [
      t('CAPTAIN_EXPERIENCE.WORKSPACE.HEALTH_NEEDS_ATTENTION'),
      'ruby',
    ],
    not_tested: [t('CAPTAIN_EXPERIENCE.WORKSPACE.HEALTH_NOT_TESTED'), 'amber'],
    unknown: [t('CAPTAIN_EXPERIENCE.WORKSPACE.HEALTH_UNKNOWN'), 'slate'],
  };
  const [label, tone] = presentations[status] || presentations.unknown;
  return { label, tone };
};
